import classNames from 'classnames';

function InputNumber({ className = '', ...props }) {
  const handleChange = (event) => {
    event.target.value = isNaN(event.target.value) ? props.value : event.target.value;
    props.onChange(event);
  };

  return (
    <>
      <input className={classNames(className)} type='text' {...props} onChange={handleChange} />
      {/* {error && <div className='font-12px red'>{error}</div>} */}
    </>
  );
}

export default InputNumber;
